var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid-cols-10 gap-4 base-rounding bg-gray-900 text-bone-white"},[_c('div',{staticClass:"col-span-12 text-center px-8 py-12 lg:py-20 lg:col-span-8 lg:col-start-2"},[_c('p',{staticClass:"text-responsive-xl font-bold mb-8"},[_vm._v("“"+_vm._s(_vm.text)+"”")]),_vm._v(" "),_c('span',[_vm._v("Harry Houdini")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }